module.exports = __webpack_public_path__ + "img/neudorf-reviews.3338f050.jpg";